// extracted by css-extract-rspack-plugin
export default {"actions":"LabeledInputWithTextBuildingBlock_actions__qgZbl","icon":"LabeledInputWithTextBuildingBlock_icon__XFYim"};